<template>
  <div>
    <div class="m-4 flex items-center justify-center text-headline-l">
      <div v-if="error.statusCode === '404'">
        {{ $t('errors.not_found') }}
      </div>
      <div v-else>
        {{ `${$t('errors.generic')}: ${error.statusCode}` }}
      </div>
    </div>

    <div class="m-4 flex items-center justify-center text-headline-l">
      <NuxtLink :to="jobsHrPaths.home({ locale })" class="btn-primary-color-m">{{ $t('errors.go_back') }}</NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { jobsHrPaths } from '@ramp106/omrjs-routing'
import { useI18n } from 'vue-i18n'

import { NuxtLink } from '#components'

const { locale } = useI18n()

defineProps({
  error: {
    type: Object,
    default: () => {
      return { statusCode: 500 }
    },
  },
})
</script>
